import { useState } from 'react';
import { FavouriteLockerIntegratorOption } from '../data/LockerDataTypes';
import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';


type ClientProps = {
    clientHasFavouriteLockerEnabled: FavouriteLockerIntegratorOption,
    setClientHasFavouriteLockerEnabled: ReactSetState<FavouriteLockerIntegratorOption>
}

const [useClientContext, Provider] = createContext<ClientProps>('ClientCtx');

const useInitClientContext = () => {
    const [clientHasFavouriteLockerEnabled, setClientHasFavouriteLockerEnabled] = useState(FavouriteLockerIntegratorOption.Unknown);

    const clientProps: ClientProps = {
        clientHasFavouriteLockerEnabled,
        setClientHasFavouriteLockerEnabled
    };
    return clientProps;
};

const ClientContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitClientContext()}>
        {children}
    </Provider>;
};

export { useClientContext, ClientContextProvider };